function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.041 3.5a3 3 0 015.918 0H19.5A1.5 1.5 0 0121 5h3a2 2 0 012 2v7a1 1 0 11-2 0V7.5a.5.5 0 00-.5-.5H21a1 1 0 01-1 1H10a1 1 0 01-1-1H6.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h4a1 1 0 110 2H6a2 2 0 01-2-2V7a2 2 0 012-2h3a1.5 1.5 0 011.5-1.5h1.541zM15 3a1 1 0 011 1 1 1 0 001 1h1.5a.5.5 0 01.5.5v.4a.1.1 0 01-.1.1h-7.8a.1.1 0 01-.1-.1v-.4a.5.5 0 01.5-.5H13a1 1 0 001-1 1 1 0 011-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.75 13a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H9.75zM9.75 17a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H9.75zM9 21.75a.75.75 0 01.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.34 17.282a2.743 2.743 0 011.953.799l.002.001a2.74 2.74 0 01-.024 3.891L18.744 30.5a.6.6 0 01-.275.157L14.407 31.7a.6.6 0 01-.73-.73l1.04-4.062a.6.6 0 01.158-.275l8.527-8.527a2.74 2.74 0 011.939-.823zm1.105 1.648a1.541 1.541 0 00-2.188.016l-.004.005-.757.757 2.171 2.172.763-.763a1.538 1.538 0 00.015-2.187zm-9.981 7.81l6.183-6.184 2.172 2.172-6.181 6.181-2.174-2.17zm-.716.98l-.657 2.565 2.567-.659-1.91-1.905z",
  fill: "currentColor"
})));